<section>
  <div class="wrapper">
    <div>
      <div>
        <div>
          <div class="mt_78">
            <div class="d-flex" style="justify-content: space-between;align-items: center;">
              <div class="header">
                <mat-icon aria-label="Home Page" style="cursor: pointer;" routerLink="/dashboard">home</mat-icon>
                <span class="backdrop-slash">&nbsp;/&nbsp;</span>
                <a routerLink="/camera-server/site-list">Site List</a>
                <span class="backdrop-slash">&nbsp;/</span>
                <span>&nbsp;{{potentialName}}</span>&nbsp;<span>({{potentialId}})</span>
              </div>
              <div class="action-btn">
                <button mat-raised-button color="primary" class="backgrd-btn-app" (click)="ManualSyncConfirmation()"
                  *ngIf="hasEditPrivilege || hasViewCamPrivilege">
                  <!-- <mat-icon aria-label="Manual Sync"
                    matTooltip="Manual sync - last synced at {{lastModifiedTime}}">sync</mat-icon> -->
                  <mat-icon aria-label="Manual Sync Site"
                    matTooltip="Clicking this button will sync and update all modifications.">sync</mat-icon>
                </button>
                <button mat-raised-button color="primary" class="backgrd-btn-app edit-btn" style="margin-left: 5px;"
                  matTooltip="{{ hasEditPrivilege ? 'Draw Masking' : 'View Masking' }}"
                  (click)="getMaskingDetails($event)">
                  <i class="fa fa-shield fontSize_36px"></i>
                </button>
                <button mat-raised-button color="primary" class="backgrd-btn-app" (click)="liveView($event)"
                  matTooltip="Live View">
                  <mat-icon aria-hidden="false" aria-label="live view">play_arrow</mat-icon>
                </button>
                <button mat-raised-button color="primary" class="backgrd-btn-app" (click)="handleDownloadSites()"
                  matTooltip="Download xlsx">
                  <i class="fas fa-download fontSize_36px"></i>
                </button>
                <button mat-raised-button color="primary" class="backgrd-btn-app" matTooltip="Open Cockpit-1"
                  *ngIf="isIcockpit"
                  (click)="openCockpitDialog('http://workspace.pro-vigil.com:777/ivigil-shield/manualSyncforPortal.jsp')">
                  <img src="assets/imgs/info1.svg" class="img-fluid" alt="" />
                  <!-- <mat-icon aria-hidden="false" aria-label="add icon">info</mat-icon> -->
                </button>
                <button mat-raised-button color="primary" class="backgrd-btn-app" matTooltip="Open Cockpit-2"
                  *ngIf="isIcockpit"
                  (click)="openCockpitDialog('http://workspace.pro-vigil.com:777//ivigil-shield//updatepotential.jsp')">
                  <img src="assets/imgs/info2.svg" class="img-fluid" alt="" />
                  <!-- <mat-icon aria-hidden="false" aria-label="add icon">info</mat-icon> -->
                </button>
              </div>
            </div>
            <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" [(selectedIndex)]="selectedTab"
              (selectedIndexChange)="changeTab($event)">
              <!-- Tab for site form -->
              <mat-tab label="Site Details">
                <div class="w-h-100v">
                  <div class="containt">
                    <!-- <div class="box_heading font_white">
                      <h3 class="font_white m0">
                        Site Details
                      </h3>
                    </div> -->
                    <mat-grid-list cols="2" rowHeight="102px" class="header-grid d-none">
                      <mat-grid-tile>
                        <div class="top-notes-area">
                          <h4 class="note w100">
                            Notes :- Syncing with CRM needs server restart
                          </h4>
                        </div>
                      </mat-grid-tile>
                      <mat-grid-tile>
                        <div class="top-sync-btn">
                          <button class="get-mac-btn">
                            <i class="fas fa-recycle fontSize_36px"></i>
                            <span class="new">Site Unit Deployed</span>
                          </button>
                        </div>
                        <div class="top-sync-btn">
                          <i class="material-icons fontSize_36px">close</i>
                          <button class="get-mac-btn">Is Deployed</button>
                        </div>
                      </mat-grid-tile>
                    </mat-grid-list>

                    <div class="box_heading font_white">
                      <h4 class="heading_text">Account Information</h4>
                      <mat-grid-list cols="2" rowHeight="80px" class="header-grid">
                        <mat-grid-tile class="tile-content">
                          <mat-form-field appearance="outline" class="form-feild">
                            <mat-label>Account ID</mat-label>
                            <input matInput placeholder="Account id" name="accountId" [(ngModel)]="accountId"
                              [ngModelOptions]="{standalone: true}" readonly>
                          </mat-form-field>
                        </mat-grid-tile>
                        <mat-grid-tile class="tile-content">
                          <mat-form-field appearance="outline" class="form-feild">
                            <mat-label>Potential ID</mat-label>
                            <input matInput placeholder="Potential id" name="potentialId" [(ngModel)]="potentialId"
                              [ngModelOptions]="{standalone: true}" readonly />
                          </mat-form-field>
                        </mat-grid-tile>
                      </mat-grid-list>
                      <mat-grid-list cols="2" rowHeight="80px" class="header-grid" style="display: none;">
                        <mat-grid-tile class="tile-content">
                          <mat-form-field appearance="outline" class="form-feild">
                            <mat-label>Description </mat-label>
                            <input matInput placeholder="Description" name="potentialId" [(ngModel)]="description"
                              [ngModelOptions]="{standalone: true}" readonly />
                          </mat-form-field>
                        </mat-grid-tile>
                      </mat-grid-list>
                      <div class="innerHeading d-none">
                        <button mat-raised-button>Sync with CRM </button>
                      </div>
                    </div>
                    <div class="box_heading font_white">
                      <h4 class="heading_text">Monitoring Hours </h4>
                      <div class="monitoring-hours-content">
                        <mat-grid-list cols="4" rowHeight="50px" class="header-grid">
                          <mat-grid-tile [colspan]="3" [rowspan]="1">
                            <div class="indicator-text tile-content">
                              <span class="mL_R text-weight">Monitoring Hours </span>
                              <span>{{monitoringHours}}</span>
                            </div>
                          </mat-grid-tile>
                          <mat-grid-tile>
                            <div class="indicator-text tile-content">
                              <span class="mL_R text-weight">Additional Hours </span>
                              <span class="mL_R">{{aditionalhours}}</span>
                            </div>
                          </mat-grid-tile>
                        </mat-grid-list>

                        <mat-grid-list cols="4" rowHeight="40px" class="header-grid">
                          <mat-grid-tile [colspan]="3" [rowspan]="1">
                            <div class="indicator-text tile-content">
                              <span class="mL_R text-weight">Monitoring Service </span>
                              <span class="mL_R">{{monitoringService}}</span>
                            </div>
                          </mat-grid-tile>
                          <mat-grid-tile style="display: none;">
                            <div class="indicator-text tile-content">
                              <span class="mL_R text-weight">Monitored Cameras </span>
                              <span class="mL_R">{{monitoredCamera}}</span>
                            </div>
                          </mat-grid-tile>
                        </mat-grid-list>

                        <mat-grid-list cols="4" rowHeight="40px" class="header-grid" style="display: none;">
                          <mat-grid-tile [colspan]="3" [rowspan]="1">
                            <div class="tile-content">
                              <mat-checkbox class="" [(ngModel)]="stopCaptureOutsideMonitor"
                                [ngModelOptions]="{standalone: true}" [disabled]="false">Stop capture outside monitoring
                                hours</mat-checkbox>
                            </div>
                          </mat-grid-tile>
                          <mat-grid-tile>
                            <div class="tile-content">
                              <mat-checkbox class="" [(ngModel)]="evntMonitoring" [ngModelOptions]="{standalone: true}"
                                [disabled]="false">Event Monitoring</mat-checkbox>
                            </div>
                          </mat-grid-tile>
                        </mat-grid-list>

                        <mat-grid-list cols="4" rowHeight="40px" class="header-grid" style="display: none;">
                          <mat-grid-tile [colspan]="2" [rowspan]="1">
                            <div class="indicator-text tile-content">
                              <span class="mL_R text-weight">Site Status </span>
                              <span class="mL_R">{{siteStatus}}</span>
                            </div>
                          </mat-grid-tile>
                        </mat-grid-list>
                      </div>
                    </div>
                    <div class="box_heading font_white">
                      <h4 class="heading_text">General Information</h4>
                      <div class="padding_left">
                        <mat-grid-list cols="3" rowHeight="80px" style="display: none;">
                          <mat-grid-tile>
                            <div class="w-100">
                              <mat-form-field appearance="outline" class="form-feild">
                                <mat-label>Company </mat-label>
                                <input matInput placeholder="Placeholder" name="company" [(ngModel)]="company"
                                  [ngModelOptions]="{standalone: true}" readonly />
                              </mat-form-field>
                            </div>
                          </mat-grid-tile>
                          <mat-grid-tile>
                            <div class="w-100">
                              <mat-form-field appearance="outline" class="form-feild">
                                <mat-label>Secondary Security(sss) </mat-label>
                                <input matInput placeholder="Placeholder" name="secondarySecurity"
                                  [(ngModel)]="secondarySecurity" [ngModelOptions]="{standalone: true}" readonly />
                              </mat-form-field>
                            </div>
                          </mat-grid-tile>
                          <mat-grid-tile>
                            <div class="w-100">
                              <mat-form-field appearance="outline" class="form-feild">
                                <mat-label>Outage Notification Method </mat-label>
                                <input matInput placeholder="Placeholder" name="ouatageNotificationMethods"
                                  [(ngModel)]="ouatageNotificationMethods" [ngModelOptions]="{standalone: true}"
                                  readonly />
                              </mat-form-field>
                            </div>
                          </mat-grid-tile>
                        </mat-grid-list>
                        <mat-grid-list cols="3" rowHeight="80px" style="display: none;">
                          <mat-grid-tile>
                            <div class="w-100">
                              <mat-form-field appearance="outline" class="form-feild">
                                <mat-label>Site/Job </mat-label>
                                <input matInput placeholder="Placeholder" name="siteJobs" [(ngModel)]="siteJobs"
                                  [ngModelOptions]="{standalone: true}" readonly />
                              </mat-form-field>
                            </div>
                          </mat-grid-tile>
                          <mat-grid-tile>
                            <div class="w-100">
                              <mat-form-field appearance="outline" class="form-feild">
                                <mat-label>SSS Contact </mat-label>
                                <input matInput placeholder="Placeholder" name="sssContact" [(ngModel)]="sssContact"
                                  [ngModelOptions]="{standalone: true}" readonly />
                              </mat-form-field>
                            </div>
                          </mat-grid-tile>
                          <mat-grid-tile>
                            <div class="w-100">
                              <mat-form-field appearance="outline" class="form-feild">
                                <mat-label>Police Department Name </mat-label>
                                <input matInput placeholder="Placeholder" name="polishDepartmentName"
                                  [(ngModel)]="polishDepartmentName" [ngModelOptions]="{standalone: true}" readonly />
                              </mat-form-field>
                            </div>
                          </mat-grid-tile>
                        </mat-grid-list>
                        <mat-grid-list cols="3" rowHeight="80px">
                          <mat-grid-tile>
                            <div class="w-100">
                              <mat-form-field appearance="outline" class="form-feild">
                                <mat-label>Field Service Rep </mat-label>
                                <input matInput placeholder="Placeholder" name="fieldServicRep"
                                  [(ngModel)]="fieldServicRep" [ngModelOptions]="{standalone: true}" readonly />
                              </mat-form-field>
                            </div>
                          </mat-grid-tile>
                          <mat-grid-tile>
                            <div class="w-100">
                              <mat-form-field appearance="outline" class="form-feild">
                                <mat-label>Unit ID </mat-label>
                                <input matInput placeholder="Placeholder" name="unitId" [(ngModel)]="unitId"
                                  [ngModelOptions]="{standalone: true}" readonly />
                              </mat-form-field>
                            </div>
                          </mat-grid-tile>
                          <mat-grid-tile>
                            <div class="w-100">
                              <mat-form-field appearance="outline" class="form-feild">
                                <mat-label>SalesForce Installation ID </mat-label>
                                <input matInput placeholder="SalesForce Installation ID" name="installationType"
                                  [(ngModel)]="installationType" [ngModelOptions]="{standalone: true}" readonly />
                              </mat-form-field>
                            </div>
                          </mat-grid-tile>
                        </mat-grid-list>
                        <mat-grid-list cols="3" rowHeight="80px" style="display: none;">
                          <mat-grid-tile>
                            <div class="w-100">
                              <div class="checkbox-Occupied">
                                <mat-checkbox class="active-checkbox" name="occupied" [(ngModel)]="occupied"
                                  class="">Occupied</mat-checkbox>
                              </div>
                              <!-- <mat-form-field appearance="outline" class="form-feild">
                                <mat-label>Occupied </mat-label>
                                <input matInput placeholder="Placeholder" name="occupied" [(ngModel)]="occupied"
                                  [ngModelOptions]="{standalone: true}" readonly />
                              </mat-form-field> -->
                            </div>
                          </mat-grid-tile>
                          <mat-grid-tile></mat-grid-tile>
                          <mat-grid-tile></mat-grid-tile>
                        </mat-grid-list>
                      </div>
                    </div>
                    <div class="box_heading font_white">
                      <h4 class="heading_text">Emergency Contacts</h4>
                      <div class="padding_left">
                        <mat-grid-list cols="3" rowHeight="80px">
                          <mat-grid-tile>
                            <div class="w-100">
                              <mat-form-field appearance="outline" class="form-feild">
                                <mat-label>Primary </mat-label>
                                <input matInput placeholder="Placeholder" name="emergencyPrimaryContact"
                                  [(ngModel)]="emergencyPrimaryContact" [ngModelOptions]="{standalone: true}"
                                  readonly />
                              </mat-form-field>
                            </div>
                          </mat-grid-tile>
                          <mat-grid-tile>
                            <div class="w-100">
                              <mat-form-field appearance="outline" class="form-feild">
                                <mat-label>Secondary </mat-label>
                                <input matInput placeholder="Placeholder" name="emergencySecondaryContact"
                                  [(ngModel)]="emergencySecondaryContact" [ngModelOptions]="{standalone: true}"
                                  readonly />
                              </mat-form-field>
                            </div>
                          </mat-grid-tile>
                        </mat-grid-list>
                      </div>
                    </div>
                    <div class="d-flex gap20">
                      <div class="box_heading font_white w30" style="display: none;">
                        <h4 class="heading_text">Misc Details</h4>
                        <div class="padding_left">
                          <mat-grid-list cols="3" rowHeight="80px">
                            <mat-grid-tile>
                              <div class="w-100">
                                <mat-form-field appearance="outline" class="form-feild">
                                  <mat-label>Email Address </mat-label>
                                  <input matInput placeholder="Placeholder" name="emailAddresss" type="email"
                                    pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}"
                                    [(ngModel)]="emailAddresss" [ngModelOptions]="{standalone: true}" readonly />
                                </mat-form-field>
                              </div>
                            </mat-grid-tile>
                            <mat-grid-tile>
                              <div class="w-100">
                                <mat-form-field appearance="outline" class="form-feild">
                                  <mat-label>Safe Word </mat-label>
                                  <input matInput placeholder="Placeholder" name="safeWard" [(ngModel)]="safeWard"
                                    [ngModelOptions]="{standalone: true}" readonly />
                                </mat-form-field>
                              </div>
                            </mat-grid-tile>
                            <mat-grid-tile>
                              <div class="w-100">
                                <mat-form-field appearance="outline" class="form-feild">
                                  <mat-label>Internet Source </mat-label>
                                  <input matInput placeholder="Placeholder" name="internetSource"
                                    [(ngModel)]="internetSource" [ngModelOptions]="{standalone: true}" readonly />
                                </mat-form-field>
                              </div>
                            </mat-grid-tile>
                          </mat-grid-list>
                          <mat-grid-list cols="3" rowHeight="80px">
                            <mat-grid-tile>
                              <div class="w-100">
                                <mat-form-field appearance="outline" class="form-feild">
                                  <mat-label>Cross Street </mat-label>
                                  <input matInput placeholder="Placeholder" name="crossStreet" [(ngModel)]="crossStreet"
                                    [ngModelOptions]="{standalone: true}" readonly />
                                </mat-form-field>
                              </div>
                            </mat-grid-tile>
                            <mat-grid-tile>
                              <div class="w-100">
                                <mat-form-field appearance="outline" class="form-feild">
                                  <mat-label>Cross Street-2 </mat-label>
                                  <input matInput placeholder="Placeholder" name="crossStreet2"
                                    [(ngModel)]="crossStreet2" [ngModelOptions]="{standalone: true}" readonly />
                                </mat-form-field>
                              </div>
                            </mat-grid-tile>
                            <mat-grid-tile>
                              <div class="w-100">
                                <mat-form-field appearance="outline" class="form-feild">
                                  <mat-label>Gate Code </mat-label>
                                  <input matInput placeholder="Placeholder" name="gateCode" [(ngModel)]="gateCode"
                                    [ngModelOptions]="{standalone: true}" readonly />
                                </mat-form-field>
                              </div>
                            </mat-grid-tile>
                          </mat-grid-list>
                          <mat-grid-list cols="3" rowHeight="80px">
                            <mat-grid-tile>
                              <div class="w-100">
                                <mat-form-field appearance="outline" class="form-feild">
                                  <mat-label>Alarm Customer License </mat-label>
                                  <input matInput placeholder="Placeholder" name="alarmCustomerLicence"
                                    [(ngModel)]="alarmCustomerLicence" [ngModelOptions]="{standalone: true}" readonly />
                                </mat-form-field>
                              </div>
                            </mat-grid-tile>
                            <mat-grid-tile>
                              <div class="w-100">
                                <mat-form-field appearance="outline" class="form-feild">
                                  <mat-label>Guard Tour Times </mat-label>
                                  <input matInput placeholder="Placeholder" name="gaurdTourTime"
                                    [(ngModel)]="gaurdTourTime" [ngModelOptions]="{standalone: true}" readonly />
                                </mat-form-field>
                              </div>
                            </mat-grid-tile>
                            <mat-grid-tile>
                              <div class="w-100">
                                <mat-form-field appearance="outline" class="form-feild">
                                  <mat-label>Alarm Busyness License </mat-label>
                                  <input matInput placeholder="Placeholder" name="alarmBusinessLicence"
                                    [(ngModel)]="alarmBusinessLicence" [ngModelOptions]="{standalone: true}" readonly />
                                </mat-form-field>
                              </div>
                            </mat-grid-tile>
                          </mat-grid-list>
                          <mat-grid-list cols="3" rowHeight="50px">
                            <mat-grid-tile>
                              <div class="w-100">
                                <div class="checkbox-Occupied">
                                  <mat-checkbox class="active-checkbox" name="contactOwnerFirst"
                                    [(ngModel)]="contactOwnerFirst" class="">Contact Owner First</mat-checkbox>
                                </div>
                                <!-- <mat-form-field appearance="outline" class="form-feild">
                                  <mat-label>Contact Owner First </mat-label>
                                  <input matInput placeholder="Placeholder" name="contactOwnerFirst"
                                    [(ngModel)]="contactOwnerFirst" [ngModelOptions]="{standalone: true}" readonly />
                                </mat-form-field> -->
                              </div>
                            </mat-grid-tile>
                          </mat-grid-list>
                        </div>
                      </div>
                      <div class="box_heading font_white w100">
                        <h4 class="heading_text">Address Details</h4>
                        <div class="padding_left">
                          <mat-grid-list cols="3" rowHeight="80px">
                            <mat-grid-tile>
                              <div class="w-100">
                                <mat-form-field appearance="outline" class="form-feild">
                                  <mat-label>Address </mat-label>
                                  <input matInput placeholder="Placeholder" name="address" [(ngModel)]="address"
                                    [ngModelOptions]="{standalone: true}" readonly />
                                </mat-form-field>
                              </div>
                            </mat-grid-tile>
                            <mat-grid-tile>
                              <div class="w-100">
                                <mat-form-field appearance="outline" class="form-feild">
                                  <mat-label>City </mat-label>
                                  <input matInput placeholder="Placeholder" name="city" [(ngModel)]="city"
                                    [ngModelOptions]="{standalone: true}" readonly />
                                </mat-form-field>
                              </div>
                            </mat-grid-tile>
                            <mat-grid-tile>
                              <div class="w-100">
                                <mat-form-field appearance="outline" class="form-feild">
                                  <mat-label>State</mat-label>
                                  <input matInput placeholder="state" name="state" [(ngModel)]="state"
                                    [ngModelOptions]="{standalone: true}" readonly />
                                </mat-form-field>
                              </div>
                            </mat-grid-tile>
                            <mat-grid-tile>
                              <div class="w-100">
                                <mat-form-field appearance="outline" class="form-feild">
                                  <mat-label>Zip</mat-label>
                                  <input matInput placeholder="Zip" name="zip" [(ngModel)]="zip"
                                    [ngModelOptions]="{standalone: true}" readonly />
                                </mat-form-field>
                              </div>
                            </mat-grid-tile>
                            <mat-grid-tile>
                              <div class="w-100">
                                <mat-form-field appearance="outline" class="form-feild">
                                  <mat-label>Local Police </mat-label>
                                  <input matInput placeholder="Placeholder" name="localPolish" [(ngModel)]="localPolish"
                                    [ngModelOptions]="{standalone: true}" readonly />
                                </mat-form-field>
                              </div>
                            </mat-grid-tile>
                          </mat-grid-list>
                        </div>
                      </div>
                    </div>
                    <div class="box_heading font_white">
                      <h4 class="heading_text">Field Configuration</h4>
                      <div class="w-100 mL_R ml-3">
                        <mat-grid-list cols="3" rowHeight="80px">
                          <mat-grid-tile>
                            <div class="w-100">
                              <mat-form-field appearance="outline" class="form-feild">
                                <mat-label>Analytic Platform </mat-label>
                                <mat-select name="selectedAnalyticPlateformID" [(ngModel)]="selectedAnalyticPlateformID"
                                  (ngModelChange)="handleSelectAnalytic($event)" [ngModelOptions]="{standalone: true}">
                                  <mat-option *ngFor="let analytic of analyticPlateform;"
                                    value="{{analytic.id}}">{{analytic.name}}</mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </mat-grid-tile>
                          <mat-grid-tile>
                            <div class="analytic-area">
                              <button mat-raised-button class="updat_analytic_btn" (click)="handleUpdateAnalyticId()"
                                *ngIf="hasEditPrivilege" [disabled]="isUpdateAnalyticPlatformBtn">Update
                                Analytics</button>
                            </div>
                          </mat-grid-tile>
                          <!-- <mat-grid-tile>
                            <div class="w-80">
                              <mat-form-field class="textarea-feild">
                                <mat-label>Description</mat-label>
                                <textarea matInput placeholder="Description" [(ngModel)]="description"
                                  [ngModelOptions]="{standalone: true}" rows="5" name="description" readonly>
                                </textarea>
                              </mat-form-field>
                            </div>
                          </mat-grid-tile> -->
                        </mat-grid-list>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-tab>
              <!-- Site Plan tab start-->
              <mat-tab label="Site Plan">
                <div class="site-discription p20">
                  <div class="box_heading font_white" *ngIf="hasEditPrivilege">
                    <h4 class="heading_text">Upload</h4>
                    <mat-grid-list cols="1" rowHeight="80px" class="header-grid">
                      <mat-grid-tile class="tile-content">
                        <div class="choose_file w-full">
                          <mat-form-field class="w-full">
                            <input #fileDayInput type="file"
                              class="absolute top-0 z-10 h-full w-full cursor-pointer opacity-0"
                              accept=".jpeg,.jpg,.png" (change)="selectSiteImageUpload($event)" />
                            <mat-label>Choose file</mat-label>
                            <input matInput cdkFocusInitial class="z-0" appBlockCopyPaste readonly />
                            <button mat-icon-button matSuffix (click)="fileDayInput.click()">
                              <mat-icon class="clouse_icons">cloud_upload</mat-icon>
                            </button>
                            <mat-hint class="mat-form-field-hint-end">JPEG / JPG / PNG</mat-hint>
                          </mat-form-field>
                        </div>
                      </mat-grid-tile>
                    </mat-grid-list>
                  </div>
                  <div class="box_heading font_white">
                    <h4 class="heading_text">Preview</h4>
                    <mat-grid-list cols="1" rowHeight="500px" class="header-grid">
                      <mat-grid-tile>
                        <div class="w-full preview-area-site">
                          <img src="{{uploadedPriviewImageFile}}" class="camImg">
                          <span *ngIf="uploadedPriviewImageFile === '' ||uploadedPriviewImageFile === null ">No preview
                            available</span>
                        </div>
                      </mat-grid-tile>
                    </mat-grid-list>
                  </div>
                </div>
              </mat-tab>
              <!-- Tab for camera list which is available in Site -->
              <mat-tab label="Cameras">
                <div class="site-camera-list">
                  <div class="camera-list-component">
                    <mat-grid-list cols="3" rowHeight="70px" class="header-grid">
                      <mat-grid-tile>
                        <!-- <mat-form-field appearance="legacy" class="mat-searchbar">
                          <span matPrefix> </span>
                          <input type="text" matInput placeholder="Search" name="searchCameraFilterValue"
                            (keyup)="applyCameraFilter($event)" [(ngModel)]="searchCameraFilterValue">
                          <button matSuffix mat-button class="serach-button-icon"><mat-icon>search</mat-icon></button>
                        </mat-form-field> -->
                      </mat-grid-tile>
                      <mat-grid-tile></mat-grid-tile>
                      <mat-grid-tile>
                        <div class="bottom-button">
                          <button mat-raised-button class="remove-btn"
                            *ngIf="this.selection.selected.length !== 0 && hasEditPrivilege" (click)="removeCamera()">
                            <mat-icon aria-hidden="false" aria-label="delete icon">delete</mat-icon>
                            Remove
                          </button>
                          <button mat-raised-button class="add-btn" (click)="addCameraInSite()"
                            *ngIf="hasEditPrivilege">
                            <mat-icon aria-hidden="false" aria-label="add icon">add</mat-icon>
                            Add camera
                          </button>
                          <div class="import-camera d-none">
                            <input #importCameraInSite type="file" accept=".xls, .xlsx" (change)="importCamera($event)"
                              style="display: none;" />
                            <input matInput style="display: none;" />
                            <button mat-raised-button class="import-camera-btn" (click)="importCameraInSite.click()">
                              <mat-icon class="clouse_icons">cloud_upload</mat-icon>
                              Choose File
                            </button>
                            <mat-error *ngIf="importCameraFileError" class="error-msg">Please upload Excel file.
                            </mat-error>
                          </div>
                        </div>
                      </mat-grid-tile>
                    </mat-grid-list>
                  </div>

                  <div class="camera-list-table">
                    <div class="mat-elevation-z8 table-pagination">
                      <table mat-table #sortCamera="matSort" [dataSource]="dataSourceCamera" class="mat-elevation-z8" matSort
                        matSortActive="created" matSortDisableClear matSortDirection="desc">

                        <!-- Checkbox Column -->
                        <ng-container matColumnDef="select">
                          <th mat-header-cell *matHeaderCellDef class="table-header">
                            <!-- <mat-checkbox (change)="$event ? masterToggle() : null"
                              [checked]="selection.hasValue() && isAllSelected()"
                              [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                            </mat-checkbox> -->
                          </th>
                          <td mat-cell *matCellDef="let row">
                            <mat-checkbox (click)="$event.stopPropagation()"
                              (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)"
                              [aria-label]="checkboxLabel(row)">
                            </mat-checkbox>
                          </td>
                        </ng-container>

                        <!-- unique_id Column -->
                        <ng-container matColumnDef="unique_id">
                          <th mat-header-cell *matHeaderCellDef> Cam Unique ID </th>
                          <td mat-cell *matCellDef="let element; let i= index;"> {{element.camUniqueId}} </td>
                        </ng-container>

                        <!-- camera_id Column -->
                        <!--<ng-container matColumnDef="camera_id">
                          <th mat-header-cell *matHeaderCellDef> Camera ID </th>
                          <td mat-cell *matCellDef="let element"> {{element.cameraId}} </td>
                        </ng-container> -->

                        <!-- camera_name Column -->
                        <ng-container matColumnDef="cameraName">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header> Camera Name </th>
                          <td mat-cell *matCellDef="let element"> {{element.cameraName}} </td>
                        </ng-container>

                        <!-- camera_type Column -->
                        <ng-container matColumnDef="cameraType">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header> Camera Type </th>
                          <td mat-cell *matCellDef="let element"> {{element.cameraType}} </td>
                        </ng-container>

                        <!-- site_name Column -->
                        <ng-container matColumnDef="siteName">
                          <th mat-header-cell *matHeaderCellDef> Site Name </th>
                          <td mat-cell *matCellDef="let element"> {{element.siteName}} </td>
                        </ng-container>

                        <!-- PTZ Column -->
                        <!-- <ng-container matColumnDef="PTZ">
                          <th mat-header-cell *matHeaderCellDef> PTZ </th>
                          <td mat-cell *matCellDef="let element"> {{element.isPTZ}} </td>
                        </ng-container> -->

                        <!-- active Column -->
                        <ng-container matColumnDef="active">
                          <th mat-header-cell *matHeaderCellDef> Active </th>
                          <td mat-cell *matCellDef="let element"> {{element.active}} </td>
                        </ng-container>

                        <!-- active Column -->
                        <ng-container matColumnDef="analytic_name">
                          <th mat-header-cell *matHeaderCellDef> Analytic Name </th>
                          <td mat-cell *matCellDef="let element"> {{element.analyticName}} </td>
                        </ng-container>

                        <!-- connected Column -->
                        <ng-container matColumnDef="connected">
                          <th mat-header-cell *matHeaderCellDef> Status </th>
                          <td mat-cell *matCellDef="let element">
                            <span *ngIf="element.connected === true" matTooltip="Connected" class="up-status"></span>
                            <span *ngIf="element.connected === false" matTooltip="Not Connected"
                              class="down-status"></span>
                          </td>
                        </ng-container>

                        <!-- action Column -->
                        <ng-container matColumnDef="action">
                          <th mat-header-cell *matHeaderCellDef> Action </th>
                          <td mat-cell *matCellDef="let element">
                            <div class="action-btn">
                              <button mat-raised-button class="edit-btn" (click)="editCamera(element)"
                                *ngIf="hasEditPrivilege" matTooltip="Edit camera">
                                <mat-icon aria-hidden="false" aria-label="add icon">mode_edit_outline</mat-icon>
                              </button>
                              <button mat-raised-button color="primary" class="edit-btn" *ngIf="isLiveViewEnabled"
                                (click)="liveViewForSingleCamera($event, element)" matTooltip="Live View"
                                style="margin-left: 5px;">
                                <mat-icon aria-hidden="false" aria-label="live view">play_arrow</mat-icon>
                              </button>
                            </div>
                          </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsCamera"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsCamera;"
                          (click)="selectedRow($event,row)">
                        </tr>
                      </table>
                      <div class="no_record_found_msg" *ngIf="dataSourceCamera.data.length === 0 && !isLoadingCamera">
                        No Records Found!
                      </div>
                      <div class="no_record_found_msg" *ngIf="isLoadingCamera">
                        Loading camera from server...
                      </div>
                      <mat-paginator #paginatorCamera [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="pageSizeCamera"
                        [length]="totalRecordsCamera" [pageIndex]="pageIndexCamera" (page)="changePaging($event)"
                        aria-label="Select page of users">
                      </mat-paginator>
                    </div>
                  </div>
                </div>
              </mat-tab>
              <!-- <mat-tab label="Strobes">Content 2</mat-tab> -->

              <!-- Tab for Device which is available in Site -->
              <mat-tab label="Devices">
                <div class="site-camera-list">
                  <div class="camera-list-component">
                    <mat-grid-list cols="3" rowHeight="70px" class="header-grid">
                      <mat-grid-tile class="select-device">
                        <mat-form-field appearance="outline" class="form-feild select-device-configuration">
                          <mat-label>Select Device Configuration </mat-label>
                          <mat-select name="selectDeviceConfiguration" [(ngModel)]="selectDeviceConfiguration"
                            (ngModelChange)="handleGetDeviceByClass()" [ngModelOptions]="{standalone: true}">
                            <mat-option *ngFor="let deviceConfig of deviceConfigurationList;"
                              value="{{deviceConfig.value}}">{{deviceConfig.name}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </mat-grid-tile>
                      <mat-grid-tile></mat-grid-tile>
                      <mat-grid-tile>
                        <div class="bottom-button">
                          <button mat-raised-button class="remove-btn"
                            *ngIf="hasEditPrivilege && (this.selectionDevice.selected.length !== 0 || this.selectionOutputs.selected.length !== 0 || this.selectionStrobes.selected.length !== 0)"
                            (click)="removeDevice()">
                            <mat-icon aria-hidden="false" aria-label="delete icon">delete</mat-icon>
                            Remove
                          </button>
                          <div class="header-btn" *ngIf="selectDeviceConfiguration == 'OTHER_DEVICE_DATA'">
                            <button mat-raised-button class="add-btn-device" (click)="addDeviceInSite()"
                              *ngIf="hasEditPrivilege">
                              <mat-icon aria-hidden="false" aria-label="add icon">add</mat-icon>
                              Add Device
                            </button>
                          </div>
                          <div class="header-btn" *ngIf="selectDeviceConfiguration == 'OUTPUT_DATA'">
                            <button mat-raised-button class="add-btn-device" (click)="addOutputsInSite()"
                              *ngIf="hasEditPrivilege">
                              <mat-icon aria-hidden="false" aria-label="add icon">add</mat-icon>
                              Add Output
                            </button>
                          </div>
                          <div class="header-btn" *ngIf="selectDeviceConfiguration == 'STROBE_DATA'">
                            <button mat-raised-button class="add-btn-device" (click)="addStrobesInSite()"
                              *ngIf="hasEditPrivilege">
                              <mat-icon aria-hidden="false" aria-label="add icon">add</mat-icon>
                              Add Algo Strobe
                            </button>
                          </div>
                        </div>
                      </mat-grid-tile>
                    </mat-grid-list>
                  </div>

                  <div class="camera-list-table">

                    <!-- Device configuration Table -->
                    <div class="mat-elevation-z8 table-pagination"
                      *ngIf="selectDeviceConfiguration == 'OTHER_DEVICE_DATA'">
                      <table mat-table #deviceSort="matSort" [dataSource]="dataSourceDevice" class="mat-elevation-z8" matSort
                        matSortActive="created" matSortDisableClear matSortDirection="desc">

                        <!-- Checkbox Column -->
                        <ng-container matColumnDef="select">
                          <th mat-header-cell *matHeaderCellDef class="table-header">
                            <mat-checkbox (change)="$event ? masterToggleDevice() : null"
                              [checked]="selectionDevice.hasValue() && isAllSelectedDevice()"
                              [indeterminate]="selectionDevice.hasValue() && !isAllSelectedDevice()"
                              [aria-label]="checkboxLabelDevice()">
                            </mat-checkbox>
                          </th>
                          <td mat-cell *matCellDef="let row">
                            <mat-checkbox (click)="$event.stopPropagation()"
                              (change)="$event ? selectionDevice.toggle(row) : null"
                              [checked]="selectionDevice.isSelected(row)" [aria-label]="checkboxLabelDevice(row)">
                            </mat-checkbox>
                          </td>
                        </ng-container>

                        <!-- unique_id Column -->
                        <ng-container matColumnDef="deviceUniqueId">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header> Unique ID </th>
                          <td mat-cell *matCellDef="let element; let i= index;"> {{element.deviceUniqueId}} </td>
                        </ng-container>

                        <!-- Name Column -->
                        <ng-container matColumnDef="deviceName">
                          <th mat-header-cell *matHeaderCellDef> Device Name </th>
                          <td mat-cell *matCellDef="let element"> {{element.otherDeviceData.deviceName}} </td>
                        </ng-container>

                        <!-- Device type Column -->
                        <ng-container matColumnDef="deviceType">
                          <th mat-header-cell *matHeaderCellDef> Device Type </th>
                          <td mat-cell *matCellDef="let element"> {{element.otherDeviceData.deviceType}} </td>
                        </ng-container>

                        <!-- Site Name Column -->
                        <ng-container matColumnDef="siteName">
                          <th mat-header-cell *matHeaderCellDef> Site Name </th>
                          <td mat-cell *matCellDef="let element"> {{element.siteName}} </td>
                        </ng-container>

                        <!-- action Column -->
                        <ng-container matColumnDef="action">
                          <th mat-header-cell *matHeaderCellDef> Action </th>
                          <td mat-cell *matCellDef="let element">
                            <div class="action-btn">
                              <button mat-raised-button class="edit-btn" (click)="editDeviceInSite(element)"
                                matTooltip="Edit device">
                                <mat-icon aria-hidden="false" aria-label="add icon">mode_edit_outline</mat-icon>
                              </button>
                            </div>
                          </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsDevice"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsDevice;"
                          (click)="selectedRowDevice($event,row)">
                        </tr>
                      </table>
                      <div class="no_record_found_msg" *ngIf="dataSourceDevice.data.length === 0">
                        No Records Found!
                      </div>
                      <mat-paginator #devicePaginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="pageSizeDevice"
                        [length]="totalRecordsDevice" [pageIndex]="pageIndexDevice" (page)="changePagingDevice($event)"
                        aria-label="Select page of users">
                      </mat-paginator>
                    </div>
                    <!-- Outputs configuration Table -->
                    <div class="mat-elevation-z8 table-pagination" *ngIf="selectDeviceConfiguration == 'OUTPUT_DATA'">
                      <table mat-table  #outputSort="matSort" [dataSource]="dataSourceOutputs" class="mat-elevation-z8" matSort
                        matSortActive="created" matSortDisableClear matSortDirection="desc">
                        <!-- Checkbox Column -->
                        <ng-container matColumnDef="select">
                          <th mat-header-cell *matHeaderCellDef class="table-header">
                            <mat-checkbox (change)="$event ? masterToggleOutputs() : null"
                              [checked]="selectionOutputs.hasValue() && isAllSelectedOutputs()"
                              [indeterminate]="selectionOutputs.hasValue() && !isAllSelectedOutputs()"
                              [aria-label]="checkboxLabelOutputs()">
                            </mat-checkbox>
                          </th>
                          <td mat-cell *matCellDef="let row">
                            <mat-checkbox (click)="$event.stopPropagation()"
                              (change)="$event ? selectionOutputs.toggle(row) : null"
                              [checked]="selectionOutputs.isSelected(row)" [aria-label]="checkboxLabelOutputs(row)">
                            </mat-checkbox>
                          </td>
                        </ng-container>
                        <!-- unique_id Column -->
                        <ng-container matColumnDef="deviceUniqueId">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header> Unique ID</th>
                          <td mat-cell *matCellDef="let element; let i= index;"> {{element.deviceUniqueId}} </td>
                        </ng-container>
                        <!-- Display name Column -->
                        <ng-container matColumnDef="displayName">
                          <th mat-header-cell *matHeaderCellDef> Display Name </th>
                          <td mat-cell *matCellDef="let element"> {{element.outputData.displayName}} </td>
                        </ng-container>
                        <!-- Alarm type Column -->
                        <ng-container matColumnDef="type">
                          <th mat-header-cell *matHeaderCellDef> Alarm Type </th>
                          <td mat-cell *matCellDef="let element"> {{element.outputData.type}} </td>
                        </ng-container>
                        <!-- Site Name Column -->
                        <ng-container matColumnDef="siteName">
                          <th mat-header-cell *matHeaderCellDef> Site Name </th>
                          <td mat-cell *matCellDef="let element"> {{element.siteName}} </td>
                        </ng-container>
                        <!-- ipaddress Column -->
                        <ng-container matColumnDef="ipaddress">
                          <th mat-header-cell *matHeaderCellDef> IP Address </th>
                          <td mat-cell *matCellDef="let element"> {{element.outputData.ip}} </td>
                        </ng-container>
                        <!-- Port Column -->
                        <ng-container matColumnDef="port">
                          <th mat-header-cell *matHeaderCellDef> Port Number </th>
                          <td mat-cell *matCellDef="let element"> {{element.outputData.portno}} </td>
                        </ng-container>
                        <!-- action Column -->
                        <ng-container matColumnDef="action">
                          <th mat-header-cell *matHeaderCellDef> Action </th>
                          <td mat-cell *matCellDef="let element">
                            <div class="action-btn">
                              <button mat-raised-button class="edit-btn" (click)="editOutputsInSite(element)"
                                matTooltip="Edit output">
                                <mat-icon aria-hidden="false" aria-label="add icon">mode_edit_outline</mat-icon>
                              </button>
                              <button mat-raised-button class="test-outputs" (click)="testOutput(element)"
                                matTooltip="Test output">
                                <mat-icon aria-hidden="false" aria-label="test strobe">notifications</mat-icon>
                              </button>
                            </div>
                          </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsOutputs"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsOutputs;"
                          (click)="selectedRowOutputs($event,row)">
                        </tr>
                      </table>
                      <div class="no_record_found_msg" *ngIf="dataSourceOutputs.data.length === 0">
                        No Records Found!
                      </div>
                      <mat-paginator #outputPaginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="pageSizeOutputs"
                        [length]="totalRecordsOutputs" [pageIndex]="pageIndexOutputs"
                        (page)="changePagingOutputs($event)" aria-label="Select page of users">
                      </mat-paginator>
                    </div>

                    <!-- Strobes configuration Table -->
                    <div class="mat-elevation-z8 table-pagination" *ngIf="selectDeviceConfiguration == 'STROBE_DATA'">
                      <table mat-table #strobeSort="matSort" [dataSource]="dataSourceStrobes" class="mat-elevation-z8" matSort
                        matSortActive="created" matSortDisableClear matSortDirection="desc">
                        <!-- Checkbox Column -->
                        <ng-container matColumnDef="select">
                          <th mat-header-cell *matHeaderCellDef class="table-header">
                            <mat-checkbox (change)="$event ? masterToggleStrobes() : null"
                              [checked]="selectionStrobes.hasValue() && isAllSelectedStrobes()"
                              [indeterminate]="selectionStrobes.hasValue() && !isAllSelectedStrobes()"
                              [aria-label]="checkboxLabelStrobes()">
                            </mat-checkbox>
                          </th>
                          <td mat-cell *matCellDef="let row">
                            <mat-checkbox (click)="$event.stopPropagation()"
                              (change)="$event ? selectionStrobes.toggle(row) : null"
                              [checked]="selectionStrobes.isSelected(row)" [aria-label]="checkboxLabelStrobes(row)">
                            </mat-checkbox>
                          </td>
                        </ng-container>
                        <!-- Strobes unique_id Column -->
                        <ng-container matColumnDef="deviceUniqueId">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header> Strobe Unique ID</th>
                          <td mat-cell *matCellDef="let element; let i= index;"> {{element.deviceUniqueId}} </td>
                        </ng-container>
                        <!-- Strobe ID name Column -->
                        <ng-container matColumnDef="strobeId">
                          <th mat-header-cell *matHeaderCellDef> Strobe ID </th>
                          <td mat-cell *matCellDef="let element"> {{element.strobeData.strobeId}} </td>
                        </ng-container>
                        <!-- Site Name Column -->
                        <ng-container matColumnDef="siteName">
                          <th mat-header-cell *matHeaderCellDef> Site Name </th>
                          <td mat-cell *matCellDef="let element"> {{element.siteName}} </td>
                        </ng-container>
                        <!-- Strobe Name Column -->
                        <ng-container matColumnDef="name">
                          <th mat-header-cell *matHeaderCellDef> Strobe Name </th>
                          <td mat-cell *matCellDef="let element"> {{element.strobeData.name}} </td>
                        </ng-container>
                        <!-- Port Number Column -->
                        <ng-container matColumnDef="portno">
                          <th mat-header-cell *matHeaderCellDef> Port Number </th>
                          <td mat-cell *matCellDef="let element"> {{element.strobeData.portno}} </td>
                        </ng-container>
                        <!-- action Column -->
                        <ng-container matColumnDef="action">
                          <th mat-header-cell *matHeaderCellDef> Action </th>
                          <td mat-cell *matCellDef="let element">
                            <div class="action-btn">
                              <button mat-raised-button class="edit-btn" (click)="editStrobesInSite(element)"
                                matTooltip="Edit strobe">
                                <mat-icon aria-hidden="false" aria-label="add icon">mode_edit_outline</mat-icon>
                              </button>
                              <button mat-raised-button class="test-outputs" (click)="testOutput(element)"
                                matTooltip="Test strobe">
                                <mat-icon aria-hidden="false" aria-label="test strobe">notifications</mat-icon>
                              </button>
                            </div>
                          </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsStrobes"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsStrobes;"
                          (click)="selectedRowStrobes($event,row)">
                        </tr>
                      </table>
                      <div class="no_record_found_msg" *ngIf="dataSourceStrobes.data.length === 0">
                        No Records Found!
                      </div>
                      <mat-paginator #strobePaginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="pageSizeStrobes"
                        [length]="totalRecordsStrobes" [pageIndex]="pageIndexStrobes"
                        (page)="changePagingStrobes($event)" aria-label="Select page of users">
                      </mat-paginator>
                    </div>
                  </div>
                </div>
              </mat-tab>
              <!-- Views tab start-->
              <mat-tab label="Views">
                <div class="p20">
                  <mat-grid-list cols="12" rowHeight="70vh" [gutterSize]="'10px'">
                    <mat-grid-tile colspan='2' class="align_items">
                      <div class="camListBoxMain">
                        <div class="cam-list-area">
                          <!-- <mat-list role="list">
                            <mat-list-item role="listitem" class="camera-list-items"
                              *ngFor="let camlist of cameraListForSite" (click)="handaleSelectCamera(camlist)">
                              <div class="list-item">
                                {{ camlist.cameraName }}
                              </div>
                            </mat-list-item>
                          </mat-list> -->
                          <div class="no_camera_avilable_msg" *ngIf="cameraListForSite.length === 0">
                            No camera available!
                          </div>
                          <mat-selection-list color="primary" [multiple]="false"
                            (selectionChange)="handleSelectCamera($event)">
                            <mat-list-option class="camera-list-items"
                              *ngFor="let camList of cameraListForSite let i = index" [value]="camList"
                              [selected]="selectedCamObjectViews && i == indexNoOfSelectedCam">{{camList.cameraName}}</mat-list-option>
                          </mat-selection-list>
                        </div>
                      </div>
                    </mat-grid-tile>
                    <mat-grid-tile colspan='5'>
                      <div class="view-camera">
                        <span (click)="manualSyncCameraDN()" class="dn-sync-btn" *ngIf="isCameraSettingFeature">
                          <mat-icon aria-label="Manual Sync Camera"
                            matTooltip="Day/Night image manual sync for individual camera">sync</mat-icon>
                        </span>
                        <div class="image-view-area" *ngIf="dayImageUrl !== '' ">
                          <h4>Day View</h4>
                          <div class="imageview">
                            <img src={{dayImageUrl}} class="camImg">
                          </div>
                        </div>
                        <span class="no_camera_avilable_msg" *ngIf="dayImageUrl === '' ">No preview available</span>
                      </div>
                    </mat-grid-tile>
                    <mat-grid-tile colspan='5'>
                      <div class="view-camera">
                        <span (click)="manualSyncCameraDN()" class="dn-sync-btn" *ngIf="isCameraSettingFeature">
                          <mat-icon aria-label="Manual Sync Camera"
                            matTooltip="Day/Night image manual sync for individual camera">sync</mat-icon>
                        </span>
                        <div class="image-view-area" *ngIf="nightImageUrl !== '' ">
                          <h4>Night View</h4>
                          <div class="imageview">
                            <img src={{nightImageUrl}} class="camImg">
                          </div>
                        </div>
                        <span class="no_camera_avilable_msg" *ngIf="nightImageUrl === '' ">No preview available</span>
                      </div>
                    </mat-grid-tile>
                  </mat-grid-list>
                  <!-- <mat-grid-list cols="5" rowHeight="250px" *ngIf="cameraListForSite.length === 0 ">
                    <mat-grid-tile class="align_items w100">
                      <h2>Data is not available</h2>
                    </mat-grid-tile>
                  </mat-grid-list> -->
                </div>
              </mat-tab>
            </mat-tab-group>
            <div class="bottom_button">
              <button mat-raised-button color="primary" class="save-btn d-none">Save</button>
              <button mat-stroked-button color="basic" class="cancel-button" (click)="handleCancelPageOrBack()">Go
                Back</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>